import { useForm } from 'react-hook-form'
import { HoldConfirmButton } from '@/components/ui/hold-confirm-button'
import { MagicInput as Input } from '@/components/ui/magic-input'
import { withErrorCode } from '@/lib/errors'
import { useNewsletterSignup } from '../hooks/useNewsletterSignup'
import type { NewsletterSignupFormValues } from '../types'

export function NewsletterSignupWidget() {
  const { signup, status, errorMessage } = useNewsletterSignup()
  const { register, handleSubmit, formState: { errors } } = useForm<NewsletterSignupFormValues>()

  if (status === 'success') {
    return (
      <p className="text-sm text-muted-foreground">
        You're on the list — thanks for subscribing!
      </p>
    )
  }

  const isLoading = status === 'loading'

  return (
    <form
      onSubmit={(e) =>
        void handleSubmit(({ email, firstName, lastName }) =>
          signup(email, firstName, lastName),
        )(e)
      }
      className="space-y-2"
    >
      <div className="grid grid-cols-2 gap-2">
        <Input
          placeholder="First name"
          autoComplete="given-name"
          disabled={isLoading}
          {...register('firstName')}
        />
        <Input
          placeholder="Last name"
          autoComplete="family-name"
          disabled={isLoading}
          {...register('lastName')}
        />
      </div>
      <Input
        type="email"
        placeholder="Email address"
        autoComplete="email"
        disabled={isLoading}
        {...register('email', { required: true })}
      />
      {errors.email && (
        <p className="text-xs text-destructive">
          {withErrorCode('Email is required.', 'app/validation')}
        </p>
      )}
      {errorMessage && (
        <p className="text-xs text-destructive">{errorMessage}</p>
      )}
      <HoldConfirmButton type="submit" className="w-full" disabled={isLoading}>
        {isLoading ? 'Subscribing…' : 'Subscribe'}
      </HoldConfirmButton>
    </form>
  )
}
